import "./ThankYou.css";

const ThankYou = () => {
  return (
    <div className="thank-you">
      <span>* Наш сервис бесплатный, но вы можете нас отблагодарить</span>
      <iframe
        src="https://yoomoney.ru/quickpay/fundraise/button?billNumber=1DEBNRLS1OU.251016&"
        width="330"
        height="50"
        frameBorder="0"
        allowTransparency="true"
        scrolling="no"
        title={ "thank-you"}
      ></iframe>
    </div>
  );
};

export default ThankYou;